import { createSelector } from "reselect";
export const selectPlanning = state => state.planning || {};

export const selectPlanningDate = createSelector([selectPlanning], (planningState = {}) => {
  return planningState.selectedDate;
});

export const selectEvents = createSelector([selectPlanning], (planningState = {}) => {
  return planningState.events || [];
});

export const selectLuccaVacationDays = createSelector([selectPlanning], (planningState = {}) => {
  return planningState.luccaVacationDays || [];
});

export const selectPlanningIsLoading = createSelector([selectPlanning], (planningState = {}) => {
  return planningState.isLoading;
});

export const selectPlanningEmail = createSelector([selectPlanning], (planningState = {}) => {
  return planningState.selectedEmail;
});

export const selectPlanningCurrentDateRange = createSelector([selectPlanning], (planningState = {}) => {
  return planningState.currentDateRange;
});



// WEBPACK FOOTER //
// src/redux/selectors/planningSelector.js